import React from "react";

import "./Button.scss";

const Button = ({ children, onClick, disabled, style }) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };
  const disabledClass = disabled ? "disabled" : "";
  return (
    <div
      className={`Button ${disabledClass}`}
      onClick={handleClick}
      style={style}
    >
      {children}
    </div>
  );
};

export default Button;
